import { ChartFrequency } from 'wisestep-api';

export const getChartFreqForTimePeriod = {
  CURRENT_QUARTER: ChartFrequency.MONTHLY,
  YEAR_TILL_DATE: ChartFrequency.MONTHLY,
  LAST_QUARTER: ChartFrequency.MONTHLY,
  LAST_YEAR: ChartFrequency.MONTHLY,
  THIS_WEEK: ChartFrequency.DAILY,
  '7D': ChartFrequency.DAILY,
  '30D': ChartFrequency.DAILY,
  MONTH_TILL_DATE: ChartFrequency.DAILY,
  '1H': ChartFrequency.HOURLY,
  '8H': ChartFrequency.HOURLY,
  TODAY: ChartFrequency.HOURLY,
  '24H': ChartFrequency.HOURLY,
};

export const enum Widget {
  METRIC_TOTAL = 'metric_total',
  TABLE_BY_USERS = 'table_by_users',
  TABLE_TO_CLIENTS = 'table_to_clients',
  TABLE_BY_JOBTYPE = 'table_by_jobtype',
  TABLE_BY_SOURCE = 'table_by_source',
  TABLE_BY_DOWNLOAD_SOURCE = 'table_by_download_source',
  TABLE_TO_AM = 'table_to_am',
  TABLE_CLIENTWISE = 'table_clientwise',
  TABLE_BY_CLIENT_SPOC = 'table_by_client_spoc',
  TABLE_USERS_WITH_TEAMS = 'table_users_with_teams',
  TABLE_JOB_TITLE = 'table_job_title',
  TABLE_RECRUITERWISE = 'table_recruiterwise',
  STACKEDBAR_CLIENTS = 'stackedbar_clients',
  BAR_TOTAL = 'bar_total',
  TABLE_SPLIT_BY_STAGES = 'table_split_by_stages',
  TABLE_BY_AM = 'table_by_am',
  TABLE_STAGE_STATE = 'table_stage_state',
  TABLE_CANDIDATE_WISE_STAGE_DETAILS = 'table_candidate_wise_stage_details',
  TABLE_CANDIDATE_STAGE_DETAILS_WJD = 'table_candidate_wise_stage_no_joiningdate',
  TABLE_JOB_SUBMISSION_COUNT = 'jobs_by_submission_count',
  METRIC_JOINING_DATE = 'metric_joining_date',
  TABLE_JOINING_DATE = 'table_joining_date',
  TABLE_JOINING_DATE_AM_WISE = 'table_joining_date_am_wise',
  TABLE_JOINING_DATE_CLIENT_WISE = 'table_joining_date_client_wise',
  TABLE_JOINING_DATE_CLIENT_CONTACT_WISE = 'table_joining_date_client_contact_wise',
  TABLE_JOINING_DATE_TEAM_WISE = 'table_joining_date_team_wise',
  TABLE_RECRUITER_WISE_STAGES = 'table_recruiter_wise_stages',
  TABLE_TIME_TO_SERVICE = 'table_time_to_service',
  TABLE_CANDIDATE_WISE_TIME_TO_SERVICE = 'table_candidate_wise_time_to_service',
  TABLE_CANDIDATE_WISE_TIME_TO_SERVICE_MEDIAN = 'table_candidate_wise_time_to_service_median',
  METRIC_SUBMISSION_ASSIGN_TTS_MEDIAN = 'metric_submission_assign_tts_median',
  METRIC_SUBMISSION_ASSIGN_TTS_MAX = 'metric_submission_assign_tts_max',
  TABLE_SUBMISSION_ASSIGN_TIME_TO_SERVICE = 'table_submission_assign_time_to_service',
  TABLE_SUBMISSION_ASSIGN_TTS_CANDIDATE = 'table_submission_assign_tts_candidate',
  METRIC_INTERVIEW_ANALYTICS_1 = 'metric_interview_analytics_1',
  METRIC_INTERVIEW_ANALYTICS_2 = 'metric_interview_analytics_2',
  METRIC_INTERVIEW_ANALYTICS_3 = 'metric_interview_analytics_3',
  METRIC_INTERVIEW_ANALYTICS_4 = 'metric_interview_analytics_4',
  METRIC_INTERVIEW_ANALYTICS_1_TO_4 = 'metric_interview_analytics_1_to_4',
  METRIC_INTERVIEW_ANALYTICS_ADVANCED_2_TO_4 = 'metric_interview_analytics_advanced_2_to_4',
  TABLE_INTERVIEW_ANALYTICS_1 = 'table_interview_analytics_1',
  TABLE_INTERVIEW_ANALYTICS_2 = 'table_interview_analytics_2',
  TABLE_INTERVIEW_ANALYTICS_3 = 'table_interview_analytics_3',
  TABLE_INTERVIEW_ANALYTICS_4 = 'table_interview_analytics_4',
  TABLE_INTERVIEW_ANALYTICS_1_TO_4 = 'table_interview_analytics_1_to_4',
  TABLE_INTERVIEW_ANALYTICS_ADVANCED_2_TO_4 = 'table_interview_analytics_advanced_2_to_4',
}

export const enum ClientNotesWidget {
  METRIC_TOTAL = 'metric_total',
  METRIC_TOTAL_TYPE_WISE = 'metric_total_type_wise',
  METRIC_TOTAL_CLIENT = 'metric_total_client',
  METRIC_TOTAL_CLIENT_SPOC = 'metric_total_clientspoc',
  TABLE_CLIENT = 'table_client',
  TABLE_CLIENT_SPOC = 'table_clientspoc',
  TABLE_RECRUITER_CLIENT = 'table_recruiter_client',
  TABLE_RECRUITER_CLIENT_SPOC = 'table_recruiter_clientspoc',
  TABLE_TYPEWISE_CLIENT = 'table_typewise_client',
  TABLE_TYPEWISE_CLIENT_SPOC = 'table_typewise_clientspoc',
  BAR_CHART_CLIENT = 'bar_chart_client',
  BAR_CHART_CLIENT_SPOC = 'bar_chart_clientspoc',
}

export const enum CvUploadWidget {
  METRIC_TOTAL = 'metric_total',
  TABLE_RECRUITER = 'table_recruiter',
  BAR_CHART = 'bar_chart',
}

export const enum MappingsWidget {
  MAPPING_COUNT = 'mapping_count',
  MAPPED_STATUS_COUNT = 'mapped_status_count',
  RECRUITER_NAME = 'table_by_users',
  CLIENTS = 'table_to_clients',
  TABLE_JOB_TITLE = 'table_job_title',
  TABLE_JOB_BOARD = 'table_job_board',
  TABLE_JOB_SOURCE = 'table_job_source',
  ACCOUNT_MANAGER = 'table_account_manager',
  JOB_TYPE = 'table_job_type',
  SOURCE = 'table_by_source',
  DOWNLOAD_SOURCE = 'table_by_download_source',
  PROFILE_DOWNLOAD_SOURCE = 'table_profile_download_source',
  RECRUITER_TEAM = 'table_recruiter_team',
  JOB_TITLE = 'table_job_title',
  RECRUITER_TEAM_JOBTYPE = 'table_recruiter_team_jobtype',
  RECRUITER_DOWNLOAD_SOURCE = 'table_recruiter_download_source',
  RECRUITER_SOURCE = 'table_recruiter_source',
  RECRUITER_DOWNLOAD_SOURCE_UPLOADED = 'table_recruiter_download_source_uploaded',
  RECRUITER_SOURCE_UPLOADED = 'table_recruiter_source_uploaded',
  BAR_CHART_TREND = 'bar_chart_total',
  STACKEDBAR_CLIENTS = 'stackedbar_clients',
  TABLE_TIME_TO_SERVICE = 'table_time_to_service',
  TABLE_RECRUITERS_MAPPINGS_NO_SUBMISSIONS = 'recruiters_mappings_no_submissions',
}

export const enum PotentialRevenueWidget {
  METRIC_NET_REVENUE_GBP = 'metric_net_revenue_gbp',
  METRIC_NET_REVENUE_GBP_PERM = 'metric_net_revenue_gbp_perm',
  METRIC_NET_REVENUE_GBP_CONT = 'metric_net_revenue_gbp_cont',
  METRIC_GROSS_REVENUE_GBP = 'metric_gross_revenue_gbp',
  METRIC_GROSS_REVENUE_GBP_PERM = 'metric_gross_revenue_gbp_perm',
  METRIC_GROSS_REVENUE_GBP_CONT = 'metric_gross_revenue_gbp_cont',
  METRIC_NET_MARGIN_GBP = 'metric_net_margin_gbp',
  METRIC_NET_MARGIN_GBP_PERM = 'metric_net_margin_gbp_perm',
  METRIC_NET_MARGIN_GBP_CONT = 'metric_net_margin_gbp_cont',
  METRIC_NET_REVENUE = 'metric_net_revenue_total',
  METRIC_NET_REVENUE_PERM = 'metric_net_revenue_perm',
  METRIC_NET_REVENUE_CONT = 'metric_net_revenue_cont',
  METRIC_GROSS_REVENUE = 'metric_gross_revenue_total',
  METRIC_GROSS_REVENUE_PERM = 'metric_gross_revenue_perm',
  METRIC_GROSS_REVENUE_CONT = 'metric_gross_revenue_cont',
  METRIC_NET_MARGIN = 'metric_net_margin_total',
  METRIC_NET_MARGIN_PERM = 'metric_net_margin_perm',
  METRIC_NET_MARGIN_CONT = 'metric_net_margin_cont',
  TABLE_CLIENT_PERMANENT = 'table_client_permanent',
  TABLE_CLIENT_CONTRACT = 'table_client_contract',
  TABLE_CLIENT_CONTACT_PERMANENT = 'table_client_contact_permanent',
  TABLE_CLIENT_CONTACT_CONTRACT = 'table_client_contact_contract',
  TABLE_CANDIDATE = 'table_candidate',
  TABLE_CANDIDATE_BDEF = 'table_candidate_bdef',
  TABLE_AM_PERMANENT = 'table_am_permanent',
  TABLE_AM_CONTRACT = 'table_am_contract',
}

export const enum SmsWidget {
  METRIC_SENT = 'metric-sent',
  METRIC_RECEIVED = 'metric-received',
  BAR_CHART_SENT = 'bar-chart-sent',
  BAR_CHART_RECEIVED = 'bar-chart-received',
  TABLE_SENT = 'table-sent',
  TABLE_RECEIVED = 'table-received',
  STACKEDBAR_CHART = 'stackedbar-chart',
  TABLE_SENT_USER_ONLY = 'table-sent-user-only',
  TABLE_RECEIVED_USER_ONLY = 'table-received-user-only',
  TABLE_SENT_JOB = 'table-sent-job',
  TABLE_RECEIVED_JOB = 'table-received-job',
}

export const enum CallsWidget {
  TOTAL_METRIC = 'total-metric',
  BAR_CHART = 'bar-chart',
  RECRUITER_TABLE = 'recruiter-table',
  RECRUITER_DIRECTION_TABLE = 'recruiter-direction-table',
  RECRUITER_STATUS_TABLE = 'recruiter-status-table',
  RECRUITER_BY_TIME_TABLE = 'recruiter-by-time-table',
  TEAM_TABLE = 'team-table',
}

export const enum EmailsWidget {
  EMAIL_COUNT = 'email_count',
  EMAIL_USER = 'email_user',
  EMAIL_USER_BAR_CHART = 'email_user_bar_chart',
  EMAIL_USER_ONLY = 'email_user_only',
  EMAIL_JOB = 'email_job',
}

export const enum ApplicationWidget {
  METRIC_TOTAL = 'metric-total',
  METRIC_SOURCE = 'metric-source',
  BAR_CHART = 'bar-chart',
  STACKEDBAR_CHART_SOURCE = 'stackedbar-chart-source',
  TABLE_JOB_TITLE = 'table-job-title',
  TABLE_JOB_SOURCE = 'table-job-source',
  TABLE_JOB_BOARD = 'table-job-board',
}

export const enum CvViewExtraWidget {
  METRIC_TOTAL = 'metric_total',
  TABLE_SOURCE = 'table_source',
  TABLE_RECRUITER = 'table_recruiter',
  TABLE_JOB_BOARD = 'table_job_board',
}

export enum CvViewTableJobBoardWidget {
  TABLE_RECRUITER_DICE = 'table_recruiter_dice',
  TABLE_RECRUITER_TECHFETCH = 'table_recruiter_techfetch',
  TABLE_RECRUITER_CAREERBUILDER = 'table_recruiter_careerbuilder',
  TABLE_RECRUITER_CAREERBUILDEREDGE = 'table_recruiter_careerbuilderedge',
  TABLE_RECRUITER_MONSTERUS_CLASSIC = 'table_recruiter_monsterclassic',
  TABLE_RECRUITER_MONSTERUS_PS = 'table_recruiter_monsterps',
  TABLE_RECRUITER_MONSTEREU = 'table_recruiter_monstereu',
  TABLE_RECRUITER_JOBSERVE = 'table_recruiter_jobserve',
  TABLE_RECRUITER_CWJOBS = 'table_recruiter_cwjobs',
  TABLE_RECRUITER_CVLIBRARY = 'table_recruiter_cvlibrary',
  TABLE_RECRUITER_JOBSITE = 'table_recruiter_jobsite',
}

export enum CvViewBarChartJobBoardWidget {
  BAR_CHART_RECRUITER_DICE = 'barchart_recruiter_dice',
  BAR_CHART_RECRUITER_TECHFETCH = 'barchart_recruiter_techfetch',
  BAR_CHART_RECRUITER_CAREERBUILDER = 'barchart_recruiter_careerbuilder',
  BAR_CHART_RECRUITER_CAREERBUILDEREDGE = 'barchart_recruiter_careerbuilderedge',
  BAR_CHART_RECRUITER_MONSTERUS_CLASSIC = 'barchart_recruiter_monsterclassic',
  BAR_CHART_RECRUITER_MONSTERUS_PS = 'barchart_recruiter_monsterps',
  BAR_CHART_RECRUITER_MONSTEREU = 'barchart_recruiter_monstereu',
  BAR_CHART_RECRUITER_JOBSERVE = 'barchart_recruiter_jobserve',
  BAR_CHART_RECRUITER_CWJOBS = 'barchart_recruiter_cwjobs',
  BAR_CHART_RECRUITER_CVLIBRARY = 'barchart_recruiter_cvlibrary',
  BAR_CHART_RECRUITER_JOBSITE = 'barchart_recruiter_jobsite',
}

export const enum FollowUpWidget {
  TASK_COUNT_CREATED = 'metric-task-count-created',
  TASK_COUNT_OPEN = 'metric-task-count-open',
  TASK_COUNT_CLOSED = 'metric-task-count-closed',
  TASK_STATUS = 'table-task-status',
  TASK_STATUS_BAR = 'bar-chart-task-status',
}

export const enum NewCandidateWidget {
  COUNT_METRIC = 'count-metric',
  CANDIDATE_RECRUITER_TABLE = 'candidate-recruiter-table',
  CANDIDATE_SOURCE_TABLE = 'candidate-source-table',
  CANDIDATE_DOWNLOAD_SOURCE_TABLE = 'candidate-download-source-table',
  CANDIDATE_BAR_GRAPH = 'candidate-bar-graph',
}

export const enum LeadWidget {
  METRIC_CREATED = 'metric-created',
  METRIC_OWNED = 'metric-owned',
  METRIC_CREATED_BY_STATUS = 'metric-created-by-status',
  METRIC_OWNED_BY_STATUS = 'metric-owned-by-status',
  METRIC_UPDATED_BY_STATUS = 'metric-updated-by-status',
  TABLE_CREATED_BY_STATUS = 'table-created-by-status',
  TABLE_OWNED_BY_STATUS = 'table-owned-by-status',
  TABLE_CREATED = 'table-created',
  TABLE_OWNED = 'table-owned',
  TABLE_PIPELINE = 'table-pipeline',
  BAR_CREATED = 'bar-created',
  BAR_OWNED = 'bar-owned',
}

export const enum JobsWidget {
  METRIC_TOTAL = 'metric_total',
  TABLE_CLIENT = 'table_client',
  METRIC_STATUS_WISE = 'metric_status_wise',
  TABLE_CLIENT_STATUS_WISE = 'table_client_status_wise',
  TABLE_CLIENT_SPOC_STATUS_WISE = 'table_client_spoc_status_wise',
  METRIC_TYPE_WISE = 'metric_type_wise',
  TABLE_CLIENT_TYPE_WISE = 'table_client_type_wise',
  TABLE_CLIENT_SPOC_TYPE_WISE = 'table_client_spoc_type_wise',
  TABLE_CLIENT_SPOC = 'table_client_spoc',
  TABLE_ACCOUNT_MANAGER = 'table_account_manager',
  METRIC_ACCEPTED_NO_SUBMISSION = 'accepted-no-submission-metric',
  TABLE_ACCEPTED_NO_SUBMISSION = 'accepted-no-submission-table',
  METRIC_ACCEPTED_NO_MAPPING = 'accepted-no-mapping-metric',
  METRIC_ACCEPTED = 'accepted-metric',
  TABLE_ACCEPTED_NO_MAPPING = 'accepted-no-mapping-table',
  TABLE_SUBMISSION_COUNT = 'submission-count-table',
  BAR_CHART_TOTAL = 'bar_chart_total',
  STACKED_BAR_CHART_CLIENT = 'stacked_bar_chart_client',
  STACKED_BAR_CHART_CLIENT_CONTACT = 'stacked_bar_chart_client_contact',
  STACKED_BAR_CHART_STATUS_WISE = 'stacked_bar_chart_status_wise',
  STACKED_BAR_CHART_TYPE_WISE = 'stacked_bar_chart_type_wise',
  TABLE_JOB_TIME_TO_SERVICE = 'table_job_time_to_service',
}
